import { render } from "./BreakControls.vue?vue&type=template&id=0edb564e&scoped=true"
import script from "./BreakControls.vue?vue&type=script&lang=js"
export * from "./BreakControls.vue?vue&type=script&lang=js"

import "./break-controls.scss?vue&type=style&index=0&id=0edb564e&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edb564e"]])

export default __exports__